import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import './TrustedBy.css';
import achemaLogo from '../assets/achema-logo.jpg';
import richemontLogo from '../assets/richemont-logo.png';
import jtiLogo from '../assets/jti-logo.png';
import danfossLogo from '../assets/danfoss-logo.png';
import batLogo from '../assets/bat-logo.png';

const TrustedBy = memo(() => {
  const { t } = useTranslation();
  
  return (
    <section className="trusted-by">
      <div className="trusted-container">
        <div className="trusted-content">
          <h3>{t('trustedBy.title')}</h3>
          <div className="companies-grid">
            <div className="company-item">
              <a href="https://www.achemosgrupe.lt/" target="_blank" rel="noopener noreferrer" className="company-link" aria-label="Visit Achema website">
                <img src={achemaLogo} alt="Achema" className="company-logo company-logo-large" loading="lazy" decoding="async" />
              </a>
            </div>
            <div className="company-item">
              <a href="https://www.richemont.com/" target="_blank" rel="noopener noreferrer" className="company-link" aria-label="Visit Richemont website">
                <img src={richemontLogo} alt="Richemont" className="company-logo company-logo-large" loading="lazy" decoding="async" />
              </a>
            </div>
            <div className="company-item">
              <a href="https://www.jti.com/" target="_blank" rel="noopener noreferrer" className="company-link" aria-label="Visit JTI website">
                <img src={jtiLogo} alt="JTI" className="company-logo" loading="lazy" decoding="async" />
              </a>
            </div>
            <div className="company-item">
              <a href="https://www.danfoss.com/" target="_blank" rel="noopener noreferrer" className="company-link" aria-label="Visit Danfoss website">
                <img src={danfossLogo} alt="Danfoss" className="company-logo" loading="lazy" decoding="async" />
              </a>
            </div>
            <div className="company-item">
              <a href="https://www.bat.com/" target="_blank" rel="noopener noreferrer" className="company-link" aria-label="Visit BAT website">
                <img src={batLogo} alt="BAT" className="company-logo company-logo-bat" loading="lazy" decoding="async" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

TrustedBy.displayName = 'TrustedBy';

export default TrustedBy;
